import { useEffect, useMemo, useState } from "react";
import { Card, Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import { useDispatch, useSelector } from "react-redux";
import { collection, onSnapshot, doc, updateDoc } from "firebase/firestore";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import { firebase } from "store/slices/firebaseSlice";
import { db } from "services/firebase";
import Footer from "examples/Footer";
import DataTable from "examples/Tables/DataTable";
import { deviceColumns, formatDeviceTableData } from "./data";
import { setDevicesConfigs } from "store/slices/firebaseSlice";

function Devices() {
  const { clientId, devicesConfigs } = useSelector(firebase);
  const dispatch = useDispatch();

  const updateDeviceConfig = async (deviceId, configId, enabled) => {
    try {
      const configRef = doc(db, "Results", clientId, "devices", deviceId, "config", configId);
      await updateDoc(configRef, { enable: enabled });
    } catch (error) {
      console.error("Error updating device config:", error);
    }
  };

  useEffect(() => {
    if (!clientId) return;
    const unsubscriptions = {};
    const unsubscribeDevices = onSnapshot(
      collection(db, "Results", clientId, "devices"),
      (devices) => {
        let data = structuredClone(devicesConfigs);
        for (const device of devices.docs) {
          const unsubscribeMeasurements = onSnapshot(
            collection(db, "Results", clientId, "devices", device.id, "config"),
            (config) => {
              let confif = {};
              for (const num of config.docs) {
                const result = num.data();
                confif[num.id] = result.enable;
              }
              if (!data) {
                data = [{ id: device.id, ...confif }];
              } else {
                const existingDevice = data.find((item) => item.id === device.id);
                if (existingDevice) {
                  data = data.map((item) =>
                    item.id === device.id ? { id: device.id, ...confif } : item
                  );
                } else {
                  data = [...data, { id: device.id, ...confif }];
                }
              }
              dispatch(setDevicesConfigs(data));
            }
          );
          unsubscriptions[device.id] = unsubscribeMeasurements;
        }
      }
    );

    return () => {
      unsubscribeDevices();
      Object.values(unsubscriptions).forEach((unsubscribeMeasurements) => {
        if (unsubscribeMeasurements) {
          unsubscribeMeasurements();
        }
      });
    };
  }, [clientId]);

  const table = useMemo(
    () => ({
      columns: deviceColumns,
      rows: formatDeviceTableData(devicesConfigs, updateDeviceConfig),
    }),
    [devicesConfigs]
  );

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Client Data (Client ID: {clientId})
                </MDTypography>
              </MDBox>
              <MDBox pt={3}>
                <DataTable
                  table={table}
                  entriesPerPage={false}
                  showTotalEntries={false}
                  noEndBorder
                  pagination={{ variant: "gradient", color: "info" }}
                />
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default Devices;
